import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";

class DateControlViewModel extends BaseViewModel {

	MinValue: string;
	MaxValue: string;

	constructor ( params: BaseViewModelParams ) {
		super( params );
		this.MinValue = params.elementDescriptor?.MinValue?.toString();
		this.MaxValue = params.elementDescriptor?.MaxValue?.toString();
	};

	runValidation = () => {
		if ( !this.Value ) return this.ValidateMandatory();
		let dateValue = this.Value;
		if ( !(this.Value instanceof Date) ) {
			const splitValue = this.Value.split('.');
			dateValue = new Date(splitValue[2], splitValue[1] - 1, splitValue[0]);
		}

		if (isNaN(dateValue))
			return true;

		let gte = true;
		let lte = true;

		//проверка, что больше минимальной
		if ( !!this.MinValue ) {
			let minvalue: any = this.MinValue;
			if (typeof (minvalue) === 'string') {
				minvalue = new Date(minvalue);
			}
			gte = dateValue.getFullYear() > minvalue.getFullYear()
				|| (dateValue.getFullYear() === minvalue.getFullYear() && dateValue.getMonth() > minvalue.getMonth())
				|| (dateValue.getFullYear() === minvalue.getFullYear() && dateValue.getMonth() === minvalue.getMonth() && dateValue.getDate() >= minvalue.getDate());
		}
		//проверка, что меньше максимальной
		if ( !!this.MaxValue ) {
			let maxvalue: any = this.MaxValue;
			if (typeof (maxvalue) === 'string') {
				maxvalue = new Date(maxvalue);
			}
			lte = dateValue.getFullYear() < maxvalue.getFullYear()
				|| (dateValue.getFullYear() === maxvalue.getFullYear() && dateValue.getMonth() < maxvalue.getMonth())
				|| (dateValue.getFullYear() === maxvalue.getFullYear() && dateValue.getMonth() === maxvalue.getMonth() && dateValue.getDate() <= maxvalue.getDate());
		}

		return gte && lte;
	};

	/** Функция установки модифицированного значения даты. */
	setValue = ( newValue: string | Date | null ) => {
		// Текущая запись.
		const currentValue = this.Value;
		let modifiedNewValue = null;
		if ( !!newValue ) {
			//Обрезаем время (если запись в виде дата/время через пробел).
			if (!(newValue instanceof Date)) {
				if ( newValue.indexOf('T') !== -1 && newValue.indexOf('-') !== -1 ) {
					const arr = newValue.split('T')[0].split('-');
					modifiedNewValue = arr[2] + '.' + arr[1] + '.' + arr[0];
				} 
				else {
					// eslint-disable-next-line
					modifiedNewValue = newValue.split(' ')[0].replace(/[^0-9\.]/g, '');
				}
			} 
			else {
				// Преобразуем в строку, если дата - объект
				// (может быть в результате выполнения скрипта)
				const options: Intl.DateTimeFormatOptions = {
					year: 'numeric',
					month: 'numeric',
					day: 'numeric'
				};
				modifiedNewValue = newValue.toLocaleString("ru", options);
				//ie hack 12716
				if (modifiedNewValue !== null) {
					// eslint-disable-next-line
					modifiedNewValue = modifiedNewValue.replace(/[^ -~]/g, '').replace(/[^0-9\.]/g, '');
				}
			}
		}

		// Изменяем значение и отправляем событие на сервер только в том случае,
		// если "обрезанное" серверное значение не соответствует текущему локальному (уже обрезанному).
		if (modifiedNewValue !== currentValue) {

			//когда используется System.Datetime, то мин. значение 01.01.0001 и мы его не будем проставлять
			const isValidDate = '01.01.0001' !== modifiedNewValue;
			if ( isValidDate ) {
				// Устанавливаем значение.
				this.Value = modifiedNewValue;
		 		// this.onValueChanged.trigger(modifiedNewValue);
			}
		}

	};

	getValue = () => {
		if ( !this.Value ) return null;
		if ( typeof this.Value === "string" )
			return this.Value;
		else if ( !!this.Value.toUTCString ) {
			const date = this.Value as Date;
			// Преобразуем в строку, если дата - объект
			// (может быть в результате выполнения скрипта)
			const options: Intl.DateTimeFormatOptions = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			};
			let modifiedNewValue = date.toLocaleString("ru", options);
			// ie hack 12716
			if (modifiedNewValue !== null) {
				// eslint-disable-next-line
				modifiedNewValue = modifiedNewValue.replace(/[^ -~]/g, '').replace(/[^0-9\.]/g, '');
			}
			return modifiedNewValue;
		}
	};

};

export default DateControlViewModel;
